import { graphql } from 'react-apollo'
import { groupBy, keys } from 'ramda'
import { Layout, Table, Button } from 'antd'
import moment from 'moment'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import XLSX from 'xlsx'

import Footer from '../components/Footer'
import hookTrackingMutation from '../graphql/mutations/hookTracking'
import inboxLabel from '../helpers/inbox'
import labelsQuery from '../graphql/queries/labels'
import Navbar from '../components/Navbar'
import raceLabel from '../helpers/race_small'
import shopLabel from '../helpers/shop_small'

import '../css/table.css'

const { Content } = Layout

const getReference = (label) => {
  switch (label.app) {
    case 'shop': return label.referenceId
    case 'race': return label.data.bibs.join(', ')
    case 'inbox': return label.referenceId
    default: return '-'
  }
}

const labelMapper = {
  shop: shopLabel,
  race: raceLabel,
  inbox: inboxLabel,
}

class Labels extends Component {
  state = {
    selectedRowKeys: [],
    filteredRows: [],
    selectedLabels: [],
    filters: {},
  }
  async componentDidMount() {
    const { group } = this.props.match.params
    await this.props.labels.refetch({ group })
    this.onTableChange(null, {})
  }
  onSelectChange = (selectedRowKeys) => {
    const { labels: { labels = [] } } = this.props
    this.setState({
      selectedRowKeys,
      selectedLabels: labels.filter(label => selectedRowKeys.includes(label._id)),
    })
  }
  onTableChange = (pagination, filters, sorter) => {
    const { labels: { labels = [] } } = this.props
    this.setState({ filters })
    const filtersFunc = (label) => {
      const filterGroup = (filters.group && filters.group.length > 0 ? filters.group.includes(label.group) : true)
      const filterTracking = (filters.tracking && filters.tracking.length > 0 ? !!label.tracking : true)
      const filterSendNoti = (filters.sendHook && filters.sendHook.length > 0 ? filters.sendHook.includes(this.checkSendNoti(label)) : true)
      return filterGroup && filterTracking && filterSendNoti
    }
    this.setState({
      filteredRows: labels.filter(filtersFunc),
      selectedRowKeys: [],
    })
  }
  checkSendNoti = (label) => {
    if (label.tracking) {
      return (label.tracking.sendHook ? 'send' : 'waiting')
    }
    return '-'
  }
  sendTrackingNoti = async () => {
    const { selectedLabels } = this.state
    const labelsPromise = selectedLabels.filter(({ tracking }) => !!tracking).map(({ tracking, ...label }) => this.props.hookTracking({ variables: { labelId: label._id, trackingId: tracking._id } }))
    await Promise.all(labelsPromise)
    alert( 'Send Notification Complete' )
  }
  exportExcel = async () => {
    const { selectedLabels } = this.state
    const excelData = selectedLabels.map((label) => {
      const items = label.data.items ? label.data.items.map(item => `[${item.amount}] ${item.name}`) : []
      const shirts = label.data.shirts ? label.data.shirts.map(shirt => `[1] ${shirt}`) : []
      return {
        'Tracking type': label.tracking ? label.tracking.carrier : '',
        'Tracking code': label.tracking ? label.tracking.code : '',
        'Label ID': label._id,
        Reference: getReference(label),
        Recipient: label.recipient.replace(/\s{1,}/g, ' ').replace(/\u200B/g, ''),
        Address: label.address.replace(/\s{1,}/g, ' ').replace(/\u200B/g, ''),
        Phone: label.data.phones.join(', '),
        Items: [...items, ...shirts].join(',\n'),
        Scaned: label.tracking ? moment(label.tracking.scannedAt).format('YYYY-MM-DD HH:mm:SS') : '',
        Count: label.data.count,
        Email: label.data.emails ? label.data.emails[0] : '',
      }
    })
    const workbook = XLSX.utils.book_new()
    const worksheet = XLSX.utils.json_to_sheet(excelData)
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1')
    XLSX.writeFile(workbook, `labels-${moment().format('YYYYMMDDHHmmSS')}.xlsx`)
  }
  printLabel = async () => {
    const { selectedLabels } = this.state
    const groupedLabels = groupBy(label => label.app, selectedLabels)
    const groups = keys(groupedLabels)
    groups.asyncForEach((group) => {
      const labels = groupedLabels[group]
      const html = labelMapper[group].genLabel(labels)
      const wnd = window.open('about:blank', '')
      wnd.document.write(html)
      wnd.document.close()
    })
  }
  render() {
    const { labels: { loading, labels = [] } } = this.props
    const { selectedRowKeys, filteredRows } = this.state
    const rowSelection = {
      selectedRowKeys,
      onChange: selected => this.onSelectChange(selected),
      hideDefaultSelections: true,
      selections: [
        {
          key: 'all-data',
          text: 'Select All Data',
          onSelect: () => {
            this.setState({
              selectedRowKeys: filteredRows.map(label => label._id),
              selectedLabels: filteredRows,
            })
          },
        },
        {
          key: 'all-tracking',
          text: 'Select All Tracking',
          onSelect: () => {
            this.setState({
              selectedRowKeys: filteredRows.filter(label => !!label.tracking).map(label => label._id),
              selectedLabels: filteredRows,
            })
          },
        },
        {
          key: 'clear-selected',
          text: 'Clear selected',
          onSelect: () => {
            this.setState({
              selectedRowKeys: [],
              selectedLabels: [],
            })
          },
        },
      ],
      onSelection: this.onSelection,
    }
    const filterGroup = keys(groupBy(label => label.group, labels)).map(label => ({ text: label, value: label }))
    const filterTracking = [{ text: 'Tracking', value: true }]
    const filterSendNoti = [{ text: 'Send', value: 'send' }, { text: 'Waiting', value: 'waiting' }]
    const columns = [
      {
        title: 'Group',
        dataIndex: 'group',
        key: 'group',
        width: 150,
        filters: filterGroup,
        onFilter: (value, record) => record.group === value,
      },
      {
        title: 'Label ID',
        key: 'labelId',
        width: 100,
        className: 'text-center',
        render: record => (<span>{record._id}<br />({record.app})</span>),
      },
      {
        title: 'Reference',
        key: 'reference',
        width: 100,
        className: 'text-center',
        render: getReference,
      },
      {
        title: 'Recipient',
        dataIndex: 'recipient',
        key: 'recipient',
        width: 150,
      },
      {
        title: 'Address',
        dataIndex: 'address',
        key: 'address',
      },
      {
        title: 'Count',
        key: 'count',
        width: 60,
        className: 'text-center',
        render: record => record.data.count,
      },
      {
        title: 'Items',
        key: 'item',
        width: 200,
        /* eslint react/no-array-index-key: 0 */
        render: record => (
          <ul style={{ paddingLeft: '20px' }}>
            {record.data.items && record.data.items.map(item => (
              <li key={`${record.referenceId} ${item.name}`}>[{item.amount}] {item.name}</li>
            ))}
            {record.data.shirts && record.data.shirts.map((shirt, index) => (
              <li key={`${record.referenceId} ${shirt} ${index}`}>{shirt}</li>
            ))}
          </ul>
        ),
      },
      {
        title: 'Tracking',
        key: 'tracking',
        width: 100,
        className: 'text-center',
        filters: filterTracking,
        onFilter: (value, record) => !!record.tracking,
        render: record => (record.tracking ? <span>[{record.tracking.carrier}]<br />{record.tracking.code}</span> : '-'),
      },
      {
        title: 'Send noti',
        key: 'sendHook',
        width: 80,
        className: 'text-center',
        filters: filterSendNoti,
        onFilter: (value, record) => this.checkSendNoti(record) === value,
        /* eslint no-nested-ternary: 0 */
        render: record => (record.tracking ? (record.tracking.sendHook ? 'Send' : 'Waiting') : '-'),
      },
    ]
    return (
      <Layout>
        <Navbar selected="label:2" />
        <Content style={{ padding: '0 20px' }}>
          <div style={{ background: '#fff', padding: 24, minHeight: 'calc(100vh - 64px - 69px)' }}>
            <h2>
              Labels <small>(Selected {selectedRowKeys.length} rows{keys(this.state.filters).every(key => this.state.filters[key].length === 0) ? '' : `, Filtered ${filteredRows.length} rows`})</small>
              <Button
                type="primary"
                onClick={this.sendTrackingNoti}
                disabled={this.state.selectedLabels.length === 0}
                style={{ float: 'right' }}
              >
                Send tracking
              </Button>
              <Button
                type="primary"
                onClick={this.exportExcel}
                style={{ float: 'right', marginRight: '10px' }}
              >
                Export excel
              </Button>
              <Button
                type="primary"
                onClick={this.printLabel}
                style={{ float: 'right', marginRight: '10px' }}
              >
                Print label
              </Button>
            </h2>
            <Table
              rowSelection={rowSelection}
              dataSource={labels}
              columns={columns}
              rowKey="_id"
              pagination={{ pageSize: 50 }}
              size="middle"
              onChange={this.onTableChange}
              loading={loading}
              bordered
            />
          </div>
        </Content>
        <Footer />
      </Layout>
    )
  }
}
Labels.propTypes = {
  labels: PropTypes.shape({
    error: PropTypes.object,
    loading: PropTypes.bool,
    labels: PropTypes.array,
    refetch: PropTypes.func,
  }).isRequired,
  hookTracking: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.object,
  }).isRequired,
}
Labels.defaultProps = {}

export default graphql(hookTrackingMutation, { name: 'hookTracking' })(graphql(labelsQuery, { name: 'labels', options: { variables: { group: '' } } })(Labels))



// WEBPACK FOOTER //
// ./src/pages/Labels.js